import { create } from "zustand";

interface RevenueStoreAnalysticState {
  accountId: any;
  startDate: any;
  endDate: any;
  sumOverall: any;
  yearSelect: any;
  monthSelect: any;
  totalError: any;
  storeCode: any;
  resultId: any;
  setResultId: (resultId: any) => void;
  setStoreCode: (storeCode: any) => void;
  setYearSelect: (yearSelect: any) => void;
  setTotalError: (totalError: any) => void;
  setMonthSelect: (monthSelect: any) => void;
  setSumOverall: (sumOverall: any) => void;
  setAccountId: (accountId: any) => void;
  setStartDate: (startDate: string) => void;
  setEndDate: (endDate: string) => void;
}

export const useRevenueStoreAnalystic = create<RevenueStoreAnalysticState>((set) => ({
  accountId: null,
  startDate: null,
  endDate: null,
  sumOverall: undefined,
  storeCode: undefined,
  yearSelect: undefined,
  monthSelect: undefined,
  totalError: undefined,
  resultId: undefined,
  setResultId: (resultId) => set({ resultId }),
  setStoreCode: (storeCode) => set({ storeCode }),
  setTotalError: (totalError) => set({ totalError }),
  setYearSelect: (yearSelect) => set({ yearSelect }),
  setMonthSelect: (monthSelect) => set({ monthSelect }),
  setSumOverall: (sumOverall) => set({ sumOverall }),
  setAccountId: (accountId) => set({ accountId }),
  setStartDate: (startDate) => set({ startDate }),
  setEndDate: (endDate) => set({ endDate }),
}));
